/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { apiGet } from "@/src/services/apiClient";
import { useIsFetching } from "@tanstack/react-query";
import dayjs from "dayjs";

export const useClientVersionChecker = () => {
  const { pathname } = useLocation();
  const lastCheckTimeRef = useRef(dayjs());
  const isFetching = useIsFetching();
  /* Never change this to true as default, also only set it to true if well tested. This could result in endless refreshes */
  const [shouldRefresh, setShouldRefresh] = useState(false);

  //this ref and everything that uses it is only used to make this testable. because otherwise u run into infinity loops locally
  const lastPathRef = useRef(pathname);

  useEffect(() => {
    if (lastPathRef.current === pathname) {
      return;
    }
    async function compareClientVersion() {
      //add || true for testing on every route change
      if (dayjs(lastCheckTimeRef.current).add(1, "hour").isSameOrBefore(dayjs())) {
        const response = await apiGet("/refresh_client/build_date");

        //add || true for testing on every route change
        if (lastCheckTimeRef.current.isBefore(dayjs(response.buildDate))) {
          setShouldRefresh(true);
        } else {
          lastCheckTimeRef.current = dayjs();
        }
      }
    }

    compareClientVersion();
    lastPathRef.current = pathname;
  }, [pathname]);

  /* Any changes made in this condition should be well tested. This could result in endless refreshes */
  if (!isFetching && shouldRefresh) {
    location.reload();
  }
};
